import { useGet } from 'services/Http';

export const usePermissionCheck = (permissionToCheck) => {
    const fmhTokenResult = useGet('/authorization/access_tokens/');
    return fmhTokenResult?.permissions?.includes(permissionToCheck) ?? false;
};
